import { useContext } from 'react';

import { RouterContext, RouterContextValue } from 'features/router';

export const useRouter = (): RouterContextValue => useContext(RouterContext);
